module.exports = __webpack_public_path__ + "img/13-03_Managing  Ideas.4009b533.svg";